import { Tabs } from 'tailwindcss-stimulus-components'

export default class extends Tabs {
  hideAll () {
    this.indexValue = -1
  }
}
